import { PDPOwnFilters, PDPOwnState } from './interfaces';

export const storeName = 'pdpOwn' as const;

export type PDPOwnName = typeof storeName;

export const initialFilters: PDPOwnFilters = {
  reviewCycleIds: null,
};

export const pdpOwnInitialState: PDPOwnState = {
  items: [],
  loading: false,
  filters: { ...initialFilters },
  init: false,
  pagination: {
    limit: 0,
    page: 1,
    total: 0,
  },
  fullData: {},
  comments: {},
};
